(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Mudou a quantidade, o formulário vai sozinho. O botao "Atualizar" some
  // porque com o envio automatico ele passa a ser uma etapa a mais para fazer
  // o que ja aconteceu — mas ele existe no HTML, e sem script continua sendo
  // o unico jeito de aplicar a mudanca.
  document.querySelectorAll('[data-nt-cart-form]').forEach((form) => {
    const botao = form.querySelector('[data-nt-atualizar]');
    if (botao) botao.hidden = true;
    form.querySelectorAll('[data-nt-qtd]').forEach((campo) => {
      campo.addEventListener('change', () => form.submit());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* O card do Discord. Nasce com [hidden] no HTML de proposito: quem ja fechou
     nao pode ver um piscar antes do JS decidir. Se o JS nao rodar, ele
     simplesmente nao aparece — melhor do que aparecer sem poder ser fechado. */
  const card = document.querySelector('[data-nt-disc]');
  if (card) {
    const CHAVE = 'nt-discord-fechado';
    let fechado = false;
    try { fechado = localStorage.getItem(CHAVE) === '1'; } catch (e) {}
    if (!fechado) card.hidden = false;
    const fechar = card.querySelector('[data-nt-disc-fechar]');
    if (fechar) {
      fechar.addEventListener('click', () => {
        card.hidden = true;
        /* localStorage lanca em navegacao anonima de alguns navegadores. Se
           lancar, o card so volta na proxima visita — bem melhor que um erro
           no console e o clique nao fazendo nada. */
        try { localStorage.setItem(CHAVE, '1'); } catch (e) {}
      });
    }
  }

  /* AVISO DE VENDA. Pergunta de tempos em tempos o que ha de novo e anuncia
     CADA VENDA UMA VEZ SO. Na primeira consulta ele apenas anota qual e a
     compra mais recente e nao mostra nada — essa e a linha de corte. Sem isso,
     quem abrisse o site veria um desfile de compras antigas, que e exatamente
     o que este aviso NAO e.

     A novidade e medida pelo `id` da linha, e nao pela data: duas compras no
     mesmo segundo empatariam e uma sumiria. */
  const prova = document.querySelector('[data-nt-prova]');
  if (prova) {
    const CHAVE_FECHADA = 'nt-prova-fechada';
    const CHAVE_MUDO = 'nt-prova-mudo';
    const numero = (nome, padrao) => {
      const v = parseFloat(prova.dataset[nome]);
      return isFinite(v) && v >= 0 ? v : padrao;
    };
    const duracao = numero('ntProvaVisivel', 30) * 1000;
    const consulta = Math.max(numero('ntProvaConsulta', 20), 5) * 1000;
    const janela = numero('ntProvaJanela', 0) * 60000;
    const mostrarQuando = prova.dataset.ntProvaQuando === 'true';
    const querSom = prova.dataset.ntProvaSom === 'true';

    const raiz = document.documentElement;
    /* PILHA. Numa abertura de pre-venda o pessoal compra junto, e o aviso precisa mostrar a correria: varias
       vendas ficam na tela ao mesmo tempo, empilhadas, a mais nova embaixo. Cada uma fica o tempo do setting, para
       dar tempo de ler; com a pilha cheia, a mais antiga sai para a nova entrar. O aviso escondido do Liquid e so
       o molde: cada venda e uma copia dele. */
    const pilha = document.querySelector('[data-nt-prova-pilha]');
    const celular = window.matchMedia('(max-width: 1023.98px)');
    const maximo = () => Math.max(1, Math.round(celular.matches ? numero('ntProvaMaxCelular', 2) : numero('ntProvaMax', 5)));
    /* numa rajada as vendas entram uma a uma, com este intervalo: a pilha anda sem parar (a nova entra embaixo,
       a mais antiga sai em cima) e cada aviso ainda fica umas cinco entradas na tela, o bastante para ler */
    const ESCALONAR = 5000;

    let imagens = {};
    try {
      const cru = document.querySelector('[data-nt-prova-imagens]');
      if (cru) imagens = JSON.parse(cru.textContent) || {};
    } catch (e) { imagens = {}; }

    let dispensada = false;
    try { dispensada = sessionStorage.getItem(CHAVE_FECHADA) === '1'; } catch (e) {}
    let mudo = false;
    try { mudo = localStorage.getItem(CHAVE_MUDO) === '1'; } catch (e) {}
    const marcarMudo = () => {
      pilha.querySelectorAll('[data-nt-prova-mudo]').forEach((b) => b.setAttribute('aria-pressed', String(mudo)));
    };

    /* ---------------------------------------------------------------- som
       Navegador nenhum toca audio antes de a pessoa tocar na pagina, e nao
       avisa quando bloqueia. O contexto so nasce no primeiro toque ou tecla;
       antes disso a venda aparece calada, e tudo bem.

       O som e sintetizado: dois senos suaves, um quinto acima. Nao ha arquivo
       para hospedar nem carregar, e o volume fica exatamente onde eu escrever. */
    let audio = null;
    const destravarAudio = () => {
      if (audio || !querSom) return;
      try { audio = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) {}
    };
    if (querSom) {
      document.addEventListener('pointerdown', destravarAudio, { once: true, passive: true });
      document.addEventListener('keydown', destravarAudio, { once: true });
    }

    const tocar = () => {
      if (!audio || mudo) return;
      if (audio.state === 'suspended') audio.resume();
      const t0 = audio.currentTime;
      [[587.33, 0], [880, 0.17]].forEach(([hz, atraso]) => {
        const osc = audio.createOscillator();
        const vol = audio.createGain();
        osc.type = 'sine';
        osc.frequency.value = hz;
        /* Rampa exponencial, e nao degrau: som que comeca e termina seco
           estala. Comeca e termina em 0.0001 porque exponencial nao aceita
           zero. Ganho de 0.05 — e para ser notado, nao para assustar. */
        vol.gain.setValueAtTime(0.0001, t0 + atraso);
        vol.gain.exponentialRampToValueAtTime(0.05, t0 + atraso + 0.05);
        vol.gain.exponentialRampToValueAtTime(0.0001, t0 + atraso + 0.9);
        osc.connect(vol).connect(audio.destination);
        osc.start(t0 + atraso);
        osc.stop(t0 + atraso + 1);
      });
    };

    /* os botoes de cada aviso: o som vale para todos, e fechar qualquer um dispensa o aviso inteiro na sessao */
    pilha.addEventListener('click', (e) => {
      if (e.target.closest('[data-nt-prova-mudo]')) {
        mudo = !mudo;
        marcarMudo();
        try { localStorage.setItem(CHAVE_MUDO, mudo ? '1' : '0'); } catch (err) {}
        /* Clicar ja e interacao: se o som estava travado, destrava agora. */
        destravarAudio();
        return;
      }
      if (e.target.closest('[data-nt-prova-fechar]')) {
        dispensada = true;
        fila.length = 0;
        Array.prototype.slice.call(pilha.children).forEach(tirar);
        try { sessionStorage.setItem(CHAVE_FECHADA, '1'); } catch (err) {}
      }
    });

    /* ------------------------------------------------------------- exibir */
    /* Venda recente NAO ganha linha de tempo. A frase de cima ja diz "acabou
       de comprar"; um "agora mesmo" embaixo contava a mesma coisa de novo, com
       outras palavras. A linha so aparece quando ha distancia de verdade, o que
       hoje so acontece com o setting de janela ligado. */
    const quandoEmPalavras = (iso) => {
      const seg = (Date.now() - new Date(iso).getTime()) / 1000;
      if (!isFinite(seg) || seg < 0) return '';
      if (seg < 120) return '';
      const fmt = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });
      if (seg < 3600) return fmt.format(-Math.round(seg / 60), 'minute');
      if (seg < 86400) return fmt.format(-Math.round(seg / 3600), 'hour');
      return fmt.format(-Math.round(seg / 86400), 'day');
    };

    function atualizarRaiz() {
      raiz.classList.toggle('nt-prova-na-tela', !!pilha.querySelector('.nt-prova.is-on'));
    }

    /* tira um aviso da pilha: desliga a classe (ele desce e some) e so depois sai do documento */
    function tirar(card) {
      if (!card || card.dataset.saindo) return;
      card.dataset.saindo = '1';
      clearTimeout(card.ntTempo);
      card.classList.remove('is-on');
      atualizarRaiz();
      setTimeout(() => { card.remove(); }, 340);
    }

    const fila = [];
    let escalonando = false;
    let ultimoSom = 0;
    /* Prazo de validade do que espera na fila. O aviso afirma que a compra
       ACABOU de acontecer; uma que ficou parada quinze minutos esperando a vez
       nao pode mais ser anunciada assim. Acontece quando varias caem juntas, e
       tambem quando a aba fica em segundo plano e o navegador afrouxa os
       temporizadores — a pessoa volta e veria uma fila de vendas velhas se
       anunciando como novas. */
    const VALIDADE = 15 * 60000;

    function mostrar(c) {
      const card = prova.cloneNode(true);
      card.removeAttribute('data-nt-prova');
      card.querySelector('[data-nt-prova-nome]').textContent = c.nome;
      card.querySelector('[data-nt-prova-produto]').textContent = c.produto;
      const alvoTempo = card.querySelector('[data-nt-prova-tempo]');
      const texto = mostrarQuando ? quandoEmPalavras(c.quando) : '';
      alvoTempo.textContent = texto;
      alvoTempo.hidden = !texto;

      const alvoFoto = card.querySelector('[data-nt-prova-foto]');
      const alvoMarca = card.querySelector('[data-nt-prova-marca]');
      const foto = imagens[c.produto];
      if (foto) {
        alvoFoto.src = foto;
        alvoFoto.alt = c.produto;
        alvoFoto.hidden = false;
        if (alvoMarca) alvoMarca.hidden = true;
      } else {
        alvoFoto.hidden = true;
        if (alvoMarca) alvoMarca.hidden = false;
      }

      pilha.appendChild(card);
      card.hidden = false;
      /* Uma leitura de layout entre tirar o [hidden] e ligar a classe: sem ela o navegador ve os dois estados na
         mesma passada e nao anima nada (requestAnimationFrame nao roda em aba de fundo) */
      void card.offsetWidth;
      card.classList.add('is-on');
      atualizarRaiz();
      marcarMudo();
      /* numa rajada o som toca so no comeco: vinte toques seguidos viram alarme */
      if (Date.now() - ultimoSom > 20000) {
        tocar();
        ultimoSom = Date.now();
      }
      card.ntTempo = setTimeout(() => tirar(card), duracao);
    }

    /* sem fila, cada aviso fica o tempo todo do setting. Numa rajada, com a pilha cheia, o mais antigo sai em
       cima quando o novo entra embaixo: a pilha corre como um feed em vez de ficar parada esperando vaga */
    function bombear() {
      if (escalonando || dispensada) return;
      let c = fila.shift();
      while (c && Date.now() - new Date(c.quando).getTime() > VALIDADE) {
        c = fila.shift();
      }
      if (!c) return;
      const antigos = Array.prototype.filter.call(pilha.children, (k) => !k.dataset.saindo);
      while (antigos.length >= maximo()) tirar(antigos.shift());
      mostrar(c);
      if (fila.length) {
        escalonando = true;
        setTimeout(() => { escalonando = false; bombear(); }, ESCALONAR);
      }
    }

    /* ----------------------------------------------------------- consultar
       Os tokens que ja passaram por aqui. Antes isto era "o maior id que eu
       vi", e para funcionar a resposta publica precisava carregar o id da
       linha — que e sequencial. Quem consultasse o endereco de tempos em
       tempos veria o contador subir e mediria o volume e o ritmo de vendas da
       loja. Guardando IDENTIDADE em vez de ORDEM, o endereco publico nao conta
       mais nada sobre quantidade, e o aviso funciona igual. */
    const vistos = new Set();
    let primeira = true;

    function consultar() {
      return fetch(prova.dataset.ntProvaUrl, { headers: { accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status))))
        .then((dados) => {
          /* Vem da mais nova para a mais velha; anunciar na ordem em que
             aconteceram. */
          const compras = ((dados && dados.compras) || [])
            .filter((c) => c && c.token && c.nome && c.produto)
            .reverse();

          const novas = compras.filter((c) => !vistos.has(c.token));
          novas.forEach((c) => vistos.add(c.token));

          if (primeira) {
            /* A LINHA DE CORTE. Na chegada da pessoa nada e anunciado: o que
               aconteceu antes dela chegar nao e novidade para ela. Sem isto o
               aviso viraria um desfile de compras antigas, que e exatamente o
               que ele deixou de ser.

               Marcada ANTES de qualquer saida antecipada, inclusive quando a
               resposta vem vazia. Antes havia um `if (!compras.length) return`
               aqui em cima e a linha de corte nunca era marcada num periodo sem
               venda nenhuma — a PRIMEIRA venda a chegar seria engolida como se
               fosse o corte, e ninguem veria o aviso dela. */
            primeira = false;
            if (janela > 0 && novas.length) {
              const corte = Date.now() - janela;
              novas
                .filter((c) => new Date(c.quando).getTime() >= corte)
                .forEach((c) => fila.push(c));
              bombear();
            }
            return;
          }

          if (!novas.length) return;
          novas.forEach((c) => fila.push(c));
          bombear();
        })
        .catch((e) => {
          /* O aviso e enfeite: se a funcao estiver fora do ar o site segue
             igual. Vai para o console para nao virar defeito invisivel. */
          console.warn('[nt] aviso de venda indisponivel', e);
        });
    }

    /* MODO DE TESTE. Com ?prova_teste=Nome do produto no endereco, o aviso mostra uma venda ficticia so neste
       navegador, poucos segundos depois de abrir, para conferir o visual sem pedido de verdade. Nada e gravado
       nem enviado; o nome sai sempre "Teste" para o print nunca passar por venda real. Sem o parametro, nada muda */
    const parametros = new URLSearchParams(location.search);
    const provaTeste = parametros.get('prova_teste');
    if (provaTeste !== null) {
      dispensada = false;
      /* &prova_qtd=20 simula uma rajada: as vendas chegam todas juntas, como numa abertura de pre-venda */
      const qtd = Math.min(Math.max(parseInt(parametros.get('prova_qtd') || '1', 10) || 1, 1), 30);
      setTimeout(() => {
        for (let i = 1; i <= qtd; i++) {
          fila.push({ token: 'teste-' + Date.now() + '-' + i, nome: qtd > 1 ? 'Teste ' + i : 'Teste', produto: provaTeste.trim() || 'NovaTracker', quando: new Date().toISOString() });
        }
        bombear();
      }, 3000);
    }

    if (!dispensada) {
      consultar();
      setInterval(consultar, consulta);
    }
  }

  const subir = document.querySelector('[data-nt-top]');
  if (subir) {
    const GATILHO = 600;
    const conferir = () => subir.classList.toggle('is-on', window.scrollY > GATILHO);
    conferir();
    window.addEventListener('scroll', conferir, { passive: true });
    subir.addEventListener('click', () => {
      const parado = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: parado ? 'auto' : 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* AS DUAS LINHAS DO TITULO TERMINAM NO MESMO PONTO.

     Nao da para fazer isto so com CSS: as duas frases tem contagens de letra
     diferentes, entao no mesmo tamanho de fonte uma sempre passa da outra. Aqui
     "se limitar apenas as suas maos" e 2,4% mais larga que "a realidade virtual
     nao deve", e era esse o degrau que aparecia na tela.

     A conta e uma regra de tres. Mede-se cada linha uma vez com nowrap para
     saber quantos pixels ela custa por pixel de fonte; a linha MAIS LARGA vira a
     medida do bloco e fica com o tamanho que o CSS ja lhe deu; as outras
     recebem medida dividida pelo proprio custo. So se AUMENTA fonte, nunca se
     diminui, entao nada estoura a coluna.

     Essa mesma medida vai para --nt-hero-medida, e e ela que faz o apoio e os
     tres pontos pararem onde o titulo para.

     Roda depois de document.fonts.ready porque a medida de uma linha depende da
     fonte que a desenha: medida com a fonte de reserva, a conta sai errada e o
     ajuste fica visivelmente torto quando a GeBody chega. */
  (function () {
    function ajustar(titulo) {
      var linhas = titulo.querySelectorAll('.nt-hero__linha');
      var coluna = titulo.closest('.nt-hero__texto');
      if (!linhas.length || !coluna) return;

      // Empilhadas? Abaixo de 640px elas correm como um paragrafo so, e a
      // medida por linha nao quer dizer nada.
      if (getComputedStyle(linhas[0]).display !== 'block') {
        linhas.forEach(function (l) { l.style.fontSize = ''; });
        coluna.style.removeProperty('--nt-hero-medida');
        return;
      }

      var base = parseFloat(getComputedStyle(titulo).fontSize);
      var custos = [];
      linhas.forEach(function (l) {
        l.style.fontSize = '';
        var antes = l.style.whiteSpace;
        l.style.whiteSpace = 'nowrap';
        // A caixa e um bloco e ocupa a coluna toda, entao quem mede o texto e o
        // Range e nao o retangulo do elemento.
        var faixa = document.createRange();
        faixa.selectNodeContents(l);
        custos.push(faixa.getBoundingClientRect().width / base);
        l.style.whiteSpace = antes;
      });

      var medida = Math.max.apply(null, custos) * base;
      linhas.forEach(function (l, i) {
        l.style.fontSize = (medida / custos[i]).toFixed(2) + 'px';
      });
      coluna.style.setProperty('--nt-hero-medida', Math.round(medida) + 'px');
    }

    function todos() {
      document.querySelectorAll('.nt-hero__titulo').forEach(ajustar);
    }

    function iniciar() {
      todos();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(todos);
      var espera;
      addEventListener('resize', function () {
        clearTimeout(espera);
        espera = setTimeout(todos, 150);
      });
      // O editor de temas remonta a secao ao vivo, e a nova nasce sem o ajuste.
      document.addEventListener('shopify:section:load', todos);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-market-compare"] && !Shopify.designMode) return;
  try {
    
  // Converte o preco das colunas importadas pelo dolar de hoje.
  //
  // Este bloco NAO passa pelo Liquid: o que vem da loja chega por
  // data-atributo no markup.
  //
  // POR QUE SO O CAMBIO E AO VIVO. O preco de origem em dolar e o imposto sao
  // ajustes: mudam quando o concorrente mexe na tabela dele, o que e raro e o
  // dono acompanha. O cambio muda todo dia, e era ele que fazia o numero em
  // real envelhecer sozinho entre uma visita e outra.
  //
  // Buscar o preco do concorrente em tempo real seria raspar o site dele: quebra
  // na primeira mudanca de layout, e nenhum deles publica uma API.
  (function () {
    'use strict';

    var HORA = 60 * 60 * 1000;
    var CHAVE = 'nt-usd-brl';

    function guardada() {
      try {
        var bruto = sessionStorage.getItem(CHAVE);
        if (!bruto) return null;
        var d = JSON.parse(bruto);
        return Date.now() - d.em < HORA ? d.taxa : null;
      } catch (e) { return null; }
    }

    function guardar(taxa) {
      try { sessionStorage.setItem(CHAVE, JSON.stringify({ taxa: taxa, em: Date.now() })); } catch (e) {}
    }

    async function cotacao() {
      var salva = guardada();
      if (salva) return salva;
      var r = await fetch('https://economia.awesomeapi.com.br/json/last/USD-BRL');
      if (!r.ok) throw new Error('HTTP ' + r.status);
      var j = await r.json();
      var taxa = parseFloat(j.USDBRL && j.USDBRL.bid);
      if (!(taxa > 0)) throw new Error('sem cotacao');
      guardar(taxa);
      return taxa;
    }

    async function converter(secao) {
      var celulas = secao.querySelectorAll('[data-nt-usd]');
      if (!celulas.length) return;

      var taxa = await cotacao();
      var imposto = 1 + (Number(secao.dataset.ntImposto) || 0) / 100;
      var real = new Intl.NumberFormat('pt-BR', {
        style: 'currency', currency: 'BRL', maximumFractionDigits: 0
      });

      celulas.forEach(function (celula) {
        var usd = Number(celula.dataset.ntUsd);
        if (!(usd > 0)) return;
        var alvo = celula.querySelector('[data-nt-preco]');
        if (!alvo) return;
        // Arredonda para a dezena de cima: e preco de referencia, e centavo
        // num numero que muda todo dia finge uma precisao que ele nao tem.
        var brl = Math.ceil(usd * imposto * taxa / 10) * 10;
        alvo.textContent = (secao.dataset.ntPrefixo || '') + real.format(brl);
      });

      var nota = secao.querySelector('[data-nt-cotacao]');
      if (nota) {
        nota.textContent = ' ' + (secao.dataset.ntNotaCotacao || 'Dolar de hoje:') + ' ' +
          new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(taxa) + '.';
        nota.hidden = false;
      }
    }

    function ligar() {
      document.querySelectorAll('.nt-mc[data-nt-imposto]').forEach(function (secao) {
        // Falhou a consulta, fica o valor escrito a mao que ja esta na tela.
        converter(secao).catch(function () {});
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ligar, { once: true });
    } else {
      ligar();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-products"] && !Shopify.designMode) return;
  try {
    
  const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Carrossel com arraste de ponteiro. Toque nao entra: la o scroll nativo
     ja faz o trabalho e interceptar so atrapalha. */
  if (!customElements.get('nt-drag')) {
    customElements.define('nt-drag', class extends HTMLElement {
      connectedCallback() {
        this.pointerId = null;
        this.startX = 0;
        this.startScroll = 0;
        this.moved = false;

        this.addEventListener('pointerdown', this.onDown.bind(this));
        this.addEventListener('pointermove', this.onMove.bind(this));
        this.addEventListener('pointerup', this.onUp.bind(this));
        this.addEventListener('pointercancel', this.onUp.bind(this));

        // Um arraste nao pode virar clique no link do card.
        this.addEventListener('click', (evento) => {
          if (!this.moved) return;
          evento.preventDefault();
          evento.stopPropagation();
          this.moved = false;
        }, true);
        this.addEventListener('dragstart', (e) => e.preventDefault());

        const nav = this.parentElement && this.parentElement.querySelector('.nt-products__nav');
        if (nav) {
          const prev = nav.querySelector('[data-nt-prev]');
          const next = nav.querySelector('[data-nt-next]');
          if (prev) prev.addEventListener('click', () => this.step(-1));
          if (next) next.addEventListener('click', () => this.step(1));
          this.nav = { prev, next };
          this.sync = this.sync.bind(this);
          this.addEventListener('scroll', this.sync, { passive: true });
          window.addEventListener('resize', this.sync);
          this.sync();
        }
      }

      disconnectedCallback() {
        if (this.sync) window.removeEventListener('resize', this.sync);
      }

      onDown(evento) {
        if (evento.pointerType === 'touch') return;
        this.pointerId = evento.pointerId;
        this.startX = evento.clientX;
        this.startScroll = this.scrollLeft;
        this.moved = false;
        this.classList.add('is-dragging');
      }

      onMove(evento) {
        if (this.pointerId !== evento.pointerId) return;
        const dx = evento.clientX - this.startX;
        if (Math.abs(dx) > 6) {
          this.moved = true;
          if (!this.hasPointerCapture(evento.pointerId)) this.setPointerCapture(evento.pointerId);
        }
        if (!this.moved) return;
        this.scrollLeft = this.startScroll - dx;
      }

      onUp(evento) {
        if (this.pointerId !== evento.pointerId) return;
        if (this.hasPointerCapture(evento.pointerId)) this.releasePointerCapture(evento.pointerId);
        this.pointerId = null;
        this.classList.remove('is-dragging');
      }

      step(dir) {
        const card = this.querySelector('[data-nt-card]');
        const gap = parseFloat(getComputedStyle(this).columnGap) || 24;
        const passo = card ? card.offsetWidth + gap : this.clientWidth * 0.8;
        this.scrollBy({ left: dir * passo, behavior: semMovimento ? 'auto' : 'smooth' });
      }

      sync() {
        if (!this.nav) return;
        if (this.nav.prev) this.nav.prev.disabled = this.scrollLeft <= 4;
        if (this.nav.next) {
          this.nav.next.disabled = this.scrollLeft + this.clientWidth >= this.scrollWidth - 4;
        }
      }
    });
  }

  /* Filtro de categoria. Esconde e mostra os cards no proprio lugar, sem
     navegar. Sem JS os chips nao fazem nada e todos os produtos continuam
     visiveis, que e o estado correto. */
  function ligarFiltros(raiz) {
    (raiz || document).querySelectorAll('.nt-products').forEach((secao) => {
      const chips = secao.querySelectorAll('[data-nt-chip]');
      const rail = secao.querySelector('[data-nt-rail]');
      if (!chips.length || !rail) return;

      // A altura do carrossel cheio vira piso da mensagem de vazio, para a
      // secao nao encolher e crescer a cada troca de categoria. Medida, e nao
      // fixada no CSS: depende do texto e da foto de cada card.
      const nav = secao.querySelector('.nt-products__nav');
      const medir = () => {
        if (secao.classList.contains('is-empty')) return;
        const topo = rail.getBoundingClientRect().top;
        const base = (nav || rail).getBoundingClientRect().bottom;
        // As margens de fora ficam de fora do getBoundingClientRect, e a
        // mensagem de vazio nao as tem: sem somar, a secao encolhia
        // exatamente o tanto da margem acima do carrossel.
        const estilo = getComputedStyle(rail);
        let margens = (parseFloat(estilo.marginTop) || 0) + (parseFloat(estilo.marginBottom) || 0);
        if (nav) margens += parseFloat(getComputedStyle(nav).marginBottom) || 0;
        const altura = Math.round(base - topo + margens);
        if (altura > 0) secao.style.setProperty('--nt-products-min', altura + 'px');
      };
      medir();
      window.addEventListener('load', medir);

      const aplicar = (chip, rolar) => {
        chips.forEach((outro) => {
          const on = outro === chip;
          outro.classList.toggle('is-active', on);
          outro.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        const bruto = (chip.getAttribute('data-nt-match') || '').trim();
        const termos = bruto ? bruto.split(',').map((t) => t.trim()).filter(Boolean) : [];

        let visiveis = 0;
        rail.querySelectorAll('[data-nt-card]').forEach((card) => {
          const palheiro = card.getAttribute('data-nt-terms') || '';
          const casa = termos.length === 0 || termos.some((t) => palheiro.indexOf(t) !== -1);
          card.hidden = !casa;
          if (casa) visiveis += 1;
        });

        secao.classList.toggle('is-empty', visiveis === 0);
        rail.scrollTo({ left: 0, behavior: 'auto' });
        if (rail.sync) rail.sync();
        if (rolar) {
          secao.scrollIntoView({ behavior: semMovimento ? 'auto' : 'smooth', block: 'start' });
        }
      };

      chips.forEach((chip) => chip.addEventListener('click', () => aplicar(chip, false)));

      // Categoria vinda da URL: e o que faz o mega menu abrir a pagina de
      // produtos ja filtrada. O apelido de cada chip esta em data-nt-slug.
      let pedido = null;
      try {
        pedido = new URLSearchParams(window.location.search).get('categoria');
      } catch (e) {
        pedido = null;
      }
      if (!pedido) return;
      pedido = pedido.trim().toLowerCase();
      for (const chip of chips) {
        if ((chip.getAttribute('data-nt-slug') || '').toLowerCase() === pedido) {
          aplicar(chip, true);
          break;
        }
      }
    });
  }

  ligarFiltros(document);
  document.addEventListener('shopify:section:load', (evento) => ligarFiltros(evento.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-reviews"] && !Shopify.designMode) return;
  try {
    
  /* capa do youtube no cartão: a grande falta em parte dos vídeos, e no lugar dela vem um cinza de 120px.
     a média tem faixas pretas em cima e embaixo; a classe avisa o css para cortá-las */
  (function () {
    function capa(img) {
      var media = img.getAttribute('data-nt-yt-capa');
      if (!media || (img.complete && img.naturalWidth > 120)) return;
      if (!img.complete) return;
      img.removeAttribute('data-nt-yt-capa');
      img.classList.add('nt-rev__yt-media');
      img.src = media;
    }
    function conferir(evento) {
      var img = evento.target;
      if (img && img.matches && img.matches('img[data-nt-yt-capa]')) capa(img);
    }
    document.addEventListener('load', conferir, true);
    document.addEventListener('error', conferir, true);
    document.querySelectorAll('img[data-nt-yt-capa]').forEach(capa);
  })();

  /* leitor da avaliação inteira. o cartão inteiro abre o diálogo, que copia os dados do cartão */
  (function () {
    var contador = 0;

    /* a foto inteira no leitor vem no tamanho da caixa: uns 445px no desktop, a largura da tela menos a margem
       no celular. em densidade 3 ela é pedida como em densidade 2, como a do cartão. a de 1800px fica para o ampliar */
    var TELA = '(min-width: 1024px) 445px, (min-resolution: 2.5dppx) and (min-width: 584px) 373px, ' +
               '(min-resolution: 2.5dppx) calc(66.7vw - 16px), (min-width: 584px) 560px, calc(100vw - 24px)';

    /* no celular a foto preenche a caixa, como na referência, com o mesmo corte 4:5 do cartão: o arquivo
       cortado tem a nitidez certa para a caixa, e a foto inteira continua no ampliar. vídeo fica inteiro.
       com o celular deitado a caixa vai para o lado do texto e ocupa uns 45% da tela */
    var CORTE = '(orientation: landscape) and (max-height: 600px) 45vw, ' +
                '(min-resolution: 2.5dppx) and (min-width: 584px) 373px, ' +
                '(min-resolution: 2.5dppx) calc(66.7vw - 16px), (min-width: 584px) 560px, calc(100vw - 24px)';
    /* a barra de controles do vídeo no chrome e no firefox deixa um vão no meio, acima da linha do vídeo, onde as
       miniaturas cabem. a do safari, e a de todo navegador do iphone e do ipad, põe a linha do vídeo no meio da
       barra: lá elas ficam acima dos botões */
    var barraComVao = (function () {
      var ua = navigator.userAgent;
      var ios = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
      var safari = /Safari/.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android/.test(ua);
      return !ios && !safari;
    })();
    var celular = window.matchMedia('(max-width: 1023.98px)');
    var deitado = window.matchMedia('(orientation: landscape) and (max-height: 600px)');
    /* a caixa do celular é 4:5 até a altura de 55% da tela. em tablet deitado ou janela baixa ela fica mais larga
       que alta, e o corte 4:5 seria cortado de novo (cabeças de fora): aí a foto fica inteira, como no desktop.
       com o celular deitado a caixa ao lado do texto é quase quadrada e o corte cabe */
    function caixaAlta() {
      if (deitado.matches) return true;
      var largura = Math.min(window.innerWidth - 24, 560);
      var altura = Math.min(largura * 1.25, window.innerHeight * 0.55);
      return altura >= largura * 0.95;
    }
    function preenche(item) {
      return !!(item && item.kind === 'image' && item.corte && celular.matches && caixaAlta());
    }

    var catalogos = new WeakMap();
    function lerCatalogo(card) {
      if (catalogos.has(card)) return catalogos.get(card);
      var tag = card.querySelector('script[data-nt-media]');
      var lista = [];
      if (tag) {
        try { lista = JSON.parse(tag.textContent) || []; } catch (erro) { lista = []; }
      }
      catalogos.set(card, lista);
      return lista;
    }

    function capaDe(item) {
      if (item.kind === 'image') return item.src;
      if (item.kind === 'youtube') return 'https://i.ytimg.com/vi/' + item.id + '/maxresdefault.jpg';
      return item.poster || '';
    }

    /* o mesmo srcset e o mesmo sizes em todo lugar que pede a foto do leitor: assim o navegador escolhe o
       mesmo arquivo, e o que foi pedido antes já está no cache quando o leitor abre */
    function porNaTela(el, item) {
      if (preenche(item)) {
        el.sizes = CORTE;
        el.srcset = item.corte;
        el.setAttribute('data-nt-corte', '');
        return;
      }
      if (!item.tela) return;
      el.sizes = TELA;
      el.srcset = item.tela;
    }

    /* pede antes a foto que o leitor vai mostrar. a capa do youtube no leitor é a mesma do cartão */
    var aquecidas = {};
    function aquecerFoto(item) {
      if (!item || item.kind === 'youtube') return;
      var chave = (preenche(item) ? item.corte : item.tela) || capaDe(item);
      if (!chave || aquecidas[chave]) return;
      var img = new Image();
      img.decoding = 'async';
      porNaTela(img, item);
      img.src = capaDe(item);
      aquecidas[chave] = img;
    }
    function aquecerLeitor(card, todas) {
      if (!card) return;
      var lista = lerCatalogo(card);
      (todas ? lista : lista.slice(0, 1)).forEach(aquecerFoto);
    }

    /* a foto de 1800px só é pedida quando a pessoa mostra que vai ampliar, para não baixar à toa */
    var grandes = {};
    function pedirGrande(item) {
      if (!item || item.kind !== 'image' || !item.src) return null;
      if (!grandes[item.src]) {
        var img = new Image();
        img.decoding = 'async';
        img.src = item.src;
        grandes[item.src] = img;
      }
      return grandes[item.src];
    }

    /* no celular a foto do leitor é o corte 4:5 e não serve de provisória para o ampliar, que mostra a foto
       inteira: a provisória é a menor foto inteira da lista da tela, pedida já no toque */
    var inteiras = {};
    function pedirInteira(item, devagar) {
      var primeira = ((item && item.tela) || '').split(',')[0].trim().split(/\s+/);
      var largura = parseInt(primeira[1], 10);
      if (!primeira[0] || !largura) return null;
      if (!inteiras[primeira[0]]) {
        var img = new Image();
        img.decoding = 'async';
        if (devagar) img.fetchPriority = 'low';
        img.src = primeira[0];
        inteiras[primeira[0]] = img;
      }
      return { url: primeira[0], w: largura };
    }

    /* enquanto a de 1800px chega, o ampliar mostra uma foto menor no tamanho que a grande vai ocupar (o srcset
       declara a largura da grande), e troca por ela sem mudar o tamanho. no desktop é a foto do leitor, que já
       está no cache; a largura do arquivo sai do width= da url, porque com srcset o naturalWidth já vem dividido
       pela densidade */
    function mostrarProvisoria(peca, origem, item) {
      if (!item || !item.w || !origem || origem.tagName !== 'IMG') return;
      var grande = pedirGrande(item);
      if (!grande || (grande.complete && grande.naturalWidth)) return;
      var url = '';
      var largura = 0;
      if (origem.hasAttribute('data-nt-corte')) {
        var menor = pedirInteira(item);
        if (menor) { url = menor.url; largura = menor.w; }
      } else if (origem.complete && origem.naturalWidth) {
        var achou = /[?&]width=(\d+)/.exec(origem.currentSrc || '');
        if (achou) { url = origem.currentSrc; largura = Number(achou[1]); }
      }
      if (!url || !largura) return;
      peca.sizes = item.w + 'px';
      peca.srcset = url + ' ' + largura + 'w';
      /* a grande entra declarada com a própria largura (densidade 1): só tirar o srcset deixava o chrome com a
         densidade da provisória, e a foto pequena crescia na troca */
      grande.addEventListener('load', function () {
        peca.srcset = item.src + ' ' + item.w + 'w';
      }, { once: true });
    }

    function quieto() {
      return window.matchMedia &&
             window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* a foto que sai do leitor para o lightbox cresce do lugar onde estava, e volta encolhendo */
    function crescerDe(peca, de) {
      if (!peca || !de || !de.width || quieto() || !peca.animate) return;
      var para = peca.getBoundingClientRect();
      if (!para.width || !para.height) return;
      peca.animate(
        [
          {
            transformOrigin: 'top left',
            transform: 'translate(' + (de.left - para.left) + 'px, ' +
                       (de.top - para.top) + 'px) scale(' +
                       (de.width / para.width) + ', ' +
                       (de.height / para.height) + ')',
            opacity: 0.55
          },
          { transformOrigin: 'top left', transform: 'none', opacity: 1 }
        ],
        { duration: 320, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
      );
    }

    function ligar(raiz) {
      var folha = raiz.querySelector('[data-nt-leitor]');
      if (!folha || folha.dataset.ligado) return;
      folha.dataset.ligado = '1';
      var gradId = 'nt-star-leitor-' + (++contador);

      function q(sel) { return folha.querySelector(sel); }
      var nome = q('[data-nt-leitor-nome]');
      var ok = q('[data-nt-leitor-ok]');
      var data = q('[data-nt-leitor-data]');
      var estrelas = q('[data-nt-leitor-estrelas]');
      var titulo = q('[data-nt-leitor-titulo]');
      var texto = q('[data-nt-leitor-texto]');
      var corpo = q('[data-nt-leitor-corpo]');
      var prod = q('[data-nt-leitor-prod]');
      var prodImg = q('[data-nt-leitor-prod-img]');
      var prodNome = q('[data-nt-leitor-prod-nome]');
      var prodLink = q('[data-nt-leitor-prod-link]');
      var painel = q('[data-nt-leitor-midia]');
      var quadro = q('[data-nt-leitor-quadro]');
      var btExpandir = q('[data-nt-leitor-expandir]');
      var minis = q('[data-nt-leitor-minis]');
      var btPrev = q('[data-nt-leitor-prev]');
      var btNext = q('[data-nt-leitor-next]');
      var contaRev = q('[data-nt-leitor-conta]');
      var grade = raiz.querySelector('nt-reviews');

      var atual = null;
      var midias = [];
      var iMidia = 0;
      /* aberto pelo "ampliar": ao fechar a foto, o leitor volta na mesma avaliação e na mesma mídia */
      var voltarPara = null;

      /* anda por todas as avaliações da aba aberta, e não só pelas da página */
      function todosCartoes() {
        if (grade && grade.cards) return grade.cards;
        return Array.prototype.filter.call(
          raiz.querySelectorAll('[data-nt-review]'),
          function (c) { return !c.dataset.ntFora; }
        );
      }

      /* a fileira acompanha o leitor: fechar cai na página da avaliação que estava aberta */
      function sincronizarPagina(card) {
        if (!grade || !grade.cards || !grade.size || !grade.to) return;
        var i = grade.cards.indexOf(card);
        if (i < 0) return;
        var pagina = Math.floor(i / grade.size);
        if (pagina !== grade.page) grade.to(pagina);
        mostrarNaFileira(card);
      }

      /* no celular a fileira rola de lado: a avaliação aberta que não está inteira à vista vai para o começo dela */
      function mostrarNaFileira(card) {
        if (grade.scrollWidth <= grade.clientWidth + 1) return;
        var borda = parseFloat(getComputedStyle(grade).scrollPaddingLeft) || 0;
        var r = card.getBoundingClientRect();
        var g = grade.getBoundingClientRect();
        if (r.left >= g.left - 1 && r.right <= g.right + 1) return;
        grade.scrollLeft += r.left - g.left - borda;
      }

      /* as estrelas do cartão, com o degradê renomeado: o id repetido apontaria para o do cartão,
         que some quando a página da fileira muda */
      function copiarEstrelas(card) {
        estrelas.textContent = '';
        var fonte = card.querySelector('.nt-stars');
        if (!fonte) return;
        var copia = fonte.cloneNode(true);
        var grad = copia.querySelector('linearGradient');
        if (grad) {
          var antigo = 'url(#' + grad.id + ')';
          grad.id = gradId;
          copia.querySelectorAll('svg[fill]').forEach(function (s) {
            if (s.getAttribute('fill') === antigo) s.setAttribute('fill', 'url(#' + gradId + ')');
          });
        }
        estrelas.appendChild(copia);
      }

      function miniDe(item) {
        if (item.mini) return item.mini;
        if (item.kind === 'youtube') return 'https://i.ytimg.com/vi/' + item.id + '/mqdefault.jpg';
        return capaDe(item);
      }
      /* a capa grande do youtube pode faltar: a reserva é a média, trocada pelo ouvinte do topo deste script */
      function reserva(el, item) {
        if (item.kind === 'youtube') el.setAttribute('data-nt-yt-capa', 'https://i.ytimg.com/vi/' + item.id + '/hqdefault.jpg');
      }

      function pintarMidia() {
        quadro.textContent = '';
        painel.classList.remove('nt-rev__leitor-midia--tocando', 'nt-rev__leitor-midia--tocando-yt', 'nt-rev__leitor-midia--tocando-vao');
        var tem = midias.length > 0;
        folha.classList.toggle('nt-rev__leitor--sem-midia', !tem);
        painel.hidden = !tem;
        if (!tem) return;

        var item = midias[iMidia];
        var capa = capaDe(item);
        preenchia = preenche(item);

        /* o fundo é a própria foto, desfocada e escurecida, atrás da foto inteira. a foto que preenche a
           caixa no celular não deixa fundo à mostra */
        if (capa && !preenche(item)) {
          var fundo = document.createElement('img');
          fundo.className = 'nt-rev__quadro-fundo';
          reserva(fundo, item);
          porNaTela(fundo, item);
          fundo.src = capa;
          fundo.alt = '';
          fundo.setAttribute('aria-hidden', 'true');
          quadro.appendChild(fundo);
        }

        var img = document.createElement('img');
        img.className = 'nt-rev__quadro-media';
        reserva(img, item);
        porNaTela(img, item);
        img.src = capa;
        img.alt = '';
        quadro.appendChild(img);
        /* no celular, com o corte já na tela, a menor foto inteira vem em segundo plano: é a provisória do
           ampliar, que senão ficaria vazio até a grande chegar */
        if (preenchia) {
          img.addEventListener('load', function () { pedirInteira(item, true); }, { once: true });
        }

        if (item.kind !== 'image') {
          /* vídeo e youtube só carregam no clique */
          var play = document.createElement('button');
          play.type = 'button';
          play.className = 'nt-rev__quadro-play';
          play.setAttribute('aria-label', folha.dataset.ntPlayLabel || 'Ver vídeo');
          play.addEventListener('click', function () {
            /* o pôster do vídeo é a capa que já está na tela */
            var vista = img.currentSrc || item.poster;
            img.remove();
            play.remove();
            var tocador;
            if (item.kind === 'youtube') {
              tocador = document.createElement('iframe');
              tocador.src = 'https://www.youtube.com/embed/' + encodeURIComponent(item.id) +
                            '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
              tocador.title = 'YouTube';
              tocador.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
              tocador.allowFullscreen = true;
              tocador.setAttribute('frameborder', '0');
            } else {
              tocador = document.createElement('video');
              tocador.src = item.src;
              if (vista) tocador.poster = vista;
              tocador.controls = true;
              tocador.autoplay = true;
              tocador.playsInline = true;
            }
            tocador.className = 'nt-rev__quadro-media nt-rev__quadro-media--tocando';
            /* os controles do tocador ficam embaixo: as miniaturas sobem enquanto ele está na tela */
            painel.classList.add(item.kind === 'youtube' ? 'nt-rev__leitor-midia--tocando-yt' : 'nt-rev__leitor-midia--tocando');
            if (item.kind !== 'youtube' && barraComVao) painel.classList.add('nt-rev__leitor-midia--tocando-vao');
            quadro.appendChild(tocador);
            /* o play que tinha o foco saiu da página: o foco passa para o tocador, dentro do leitor */
            tocador.focus({ preventScroll: true });
          });
          quadro.appendChild(play);
        }

        Array.prototype.forEach.call(minis.children, function (mini, i) {
          var on = i === iMidia;
          mini.classList.toggle('is-atual', on);
          mini.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      /* com o leitor aberto, se a tela muda (cruzar 1024px, girar o tablet, encolher a janela) a foto troca
         entre inteira e preenchendo a caixa */
      var preenchia = null;
      var revisando = 0;
      function revisar() {
        revisando = 0;
        var item = midias[iMidia];
        if (folha.open && item && item.kind === 'image' && preenche(item) !== preenchia) pintarMidia();
      }
      window.addEventListener('resize', function () {
        if (!revisando) revisando = requestAnimationFrame(revisar);
      });

      /* uma miniatura por foto ou vídeo, no lugar de setas e contador; tocar troca a mídia */
      function montarMinis() {
        minis.textContent = '';
        minis.hidden = midias.length < 2;
        if (midias.length < 2) return;
        midias.forEach(function (item, i) {
          var bt = document.createElement('button');
          bt.type = 'button';
          bt.className = 'nt-rev__mini' + (item.kind === 'image' ? '' : ' nt-rev__mini--video');
          bt.setAttribute('aria-label', (item.kind === 'image' ? 'Foto ' : 'Vídeo ') + (i + 1) + ' de ' + midias.length);
          var img = document.createElement('img');
          img.src = miniDe(item);
          img.alt = '';
          img.width = 46;
          img.height = 46;
          bt.appendChild(img);
          bt.addEventListener('click', function () {
            if (i === iMidia) return;
            iMidia = i;
            pintarMidia();
          });
          minis.appendChild(bt);
        });
      }

      function abrir(card) {
        atual = card;
        var d = card.dataset;

        nome.textContent = d.ntNome || '';
        ok.hidden = !('ntVerificado' in d);
        data.textContent = d.ntData || '';
        data.hidden = !d.ntData;
        if (d.ntQuando) data.setAttribute('datetime', d.ntQuando);
        else data.removeAttribute('datetime');
        copiarEstrelas(card);

        var t = card.querySelector('.nt-rev__cardtitle');
        titulo.textContent = t ? t.textContent : '';
        titulo.hidden = !t;
        var c = card.querySelector('.nt-rev__body');
        texto.textContent = c ? c.textContent : '';
        corpo.scrollTop = 0;

        /* avaliação da loja, ou sem produto achado, fica sem a linha do produto */
        if (d.ntProdutoUrl) {
          prod.hidden = false;
          prodNome.textContent = d.ntProduto || '';
          prodLink.href = d.ntProdutoUrl;
          prodImg.hidden = !d.ntProdutoImg;
          if (d.ntProdutoImg) prodImg.src = d.ntProdutoImg;
        } else {
          prod.hidden = true;
        }

        midias = lerCatalogo(card);
        iMidia = 0;
        montarMinis();
        pintarMidia();

        sincronizarPagina(card);

        var lista = todosCartoes();
        var pos = Array.prototype.indexOf.call(lista, card);
        contaRev.textContent = '';
        var focado = document.activeElement;
        btPrev.disabled = pos <= 0;
        btNext.disabled = pos < 0 || pos >= lista.length - 1;
        /* as outras fotos desta avaliação, para a miniatura trocar na hora, e a primeira da anterior e da próxima.
           só depois da foto que está na tela: na rede lenta elas dividiriam a banda com ela */
        var vizinhas = function () {
          if (atual !== card) return;
          aquecerLeitor(card, true);
          if (pos >= 0) {
            aquecerLeitor(lista[pos - 1]);
            aquecerLeitor(lista[pos + 1]);
          }
        };
        var naTela = quadro.querySelector('img.nt-rev__quadro-media');
        if (naTela && !naTela.complete) {
          naTela.addEventListener('load', vizinhas, { once: true });
          naTela.addEventListener('error', vizinhas, { once: true });
        } else {
          vizinhas();
        }
        /* chegou na primeira ou na última com o foco na seta que acabou de desligar: o foco iria para fora
           do leitor, e as setas do teclado parariam. ele passa para a outra seta, ou para o próprio leitor */
        if ((focado === btPrev || focado === btNext) && focado.disabled) {
          var outra = focado === btPrev ? btNext : btPrev;
          (outra.disabled ? folha : outra).focus({ preventScroll: true });
        }
        return pos >= 0 ? (d.ntNome || '') + ', avaliação ' + (pos + 1) + ' de ' + lista.length : '';
      }

      function mostrar() {
        if (!folha.open) folha.showModal();
        folha.focus({ preventScroll: true });
      }

      /* a intenção de abrir pede a foto do leitor antes do clique: o mouse em cima do cartão, o foco nele,
         o dedo encostando */
      function intencao(e) {
        var card = e.target.closest && e.target.closest('[data-nt-review]');
        if (card && grade && grade.contains(card)) aquecerLeitor(card);
      }
      /* o mouse que só cruza o cartão a caminho de outro lugar não conta: ele tem de parar um instante */
      var pairando = null;
      var pausa = 0;
      raiz.addEventListener('pointerover', function (e) {
        if (e.pointerType !== 'mouse') return;
        var card = e.target.closest && e.target.closest('[data-nt-review]');
        if (card === pairando) return;
        pairando = card;
        window.clearTimeout(pausa);
        if (card) pausa = window.setTimeout(function () { if (pairando === card) intencao(e); }, 80);
      }, { passive: true });
      raiz.addEventListener('pointerdown', intencao, { passive: true });
      raiz.addEventListener('touchstart', intencao, { passive: true });
      raiz.addEventListener('focusin', intencao);

      raiz.addEventListener('click', function (e) {
        var botao = e.target.closest('[data-nt-ler]');
        if (!botao) return;
        var card = botao.closest('[data-nt-review]');
        if (!card) return;
        voltarPara = null;
        abrir(card);
        mostrar();
      });

      /* ampliar entrega o catálogo ao lightbox da página. o leitor fecha para dar lugar a ele, porque
         um elemento fixo não pinta acima de um diálogo em camada superior, e reabre quando a foto fecha */
      function expandir() {
        if (!midias.length || !atual) return;
        var lb = document.querySelector('nt-lightbox');
        if (!lb || typeof lb.open !== 'function') return;

        var origem = quadro.querySelector('.nt-rev__quadro-media');
        var de = null;
        if (origem) {
          var r = origem.getBoundingClientRect();
          de = { left: r.left, top: r.top, width: r.width, height: r.height };
        }

        voltarPara = { card: atual, midia: iMidia };
        folha.close();
        lb.open(midias, iMidia);

        var peca = lb.querySelector('.nt-lb__media');
        if (peca && peca.tagName === 'IMG' && !peca.complete) {
          mostrarProvisoria(peca, origem, midias[iMidia]);
          peca.addEventListener('load', function () { crescerDe(peca, de); }, { once: true });
        } else {
          crescerDe(peca, de);
        }
      }
      btExpandir.addEventListener('click', expandir);

      /* mouse no botão de ampliar, foco nele ou dedo encostando já pedem a foto grande */
      function vaiAmpliar() {
        if (!midias.length || !atual) return;
        pedirGrande(midias[iMidia]);
        if (preenche(midias[iMidia])) pedirInteira(midias[iMidia]);
      }
      ['pointerenter', 'focus', 'pointerdown'].forEach(function (tipo) {
        btExpandir.addEventListener(tipo, vaiAmpliar);
      });
      quadro.addEventListener('pointerdown', function (e) {
        if (e.target.classList.contains('nt-rev__quadro-media')) vaiAmpliar();
      });

      /* clicar na foto amplia, como o botão; em vídeo o clique é do play */
      quadro.addEventListener('click', function (e) {
        if (!e.target.classList.contains('nt-rev__quadro-media') || e.target.tagName !== 'IMG') return;
        if (quadro.querySelector('.nt-rev__quadro-play')) return;
        expandir();
      });

      /* reabre na volta seguinte do navegador: fechada pelo esc, a foto ainda está no meio do mesmo
         evento de tecla, e um diálogo aberto ali receberia o mesmo esc e fecharia junto */
      document.addEventListener('nt-lb-fechou', function (e) {
        if (!voltarPara) return;
        var volta = voltarPara;
        voltarPara = null;
        var de = e.detail && e.detail.de;
        window.setTimeout(function () {
          abrir(volta.card);
          if (volta.midia < midias.length) {
            iMidia = volta.midia;
            pintarMidia();
          }
          mostrar();
          crescerDe(quadro.querySelector('.nt-rev__quadro-media'), de);
        }, 0);
      });

      function andar(passo) {
        var lista = todosCartoes();
        var pos = Array.prototype.indexOf.call(lista, atual);
        var destino = lista[pos + passo];
        if (!destino) return;
        var anuncio = abrir(destino);
        /* o nome entra como texto, nunca como html: ele vem de quem escreveu a avaliação */
        contaRev.textContent = anuncio;
      }
      btPrev.addEventListener('click', function () { andar(-1); });
      btNext.addEventListener('click', function () { andar(1); });

      folha.addEventListener('keydown', function (e) {
        if (e.altKey || e.ctrlKey || e.metaKey) return;
        /* no vídeo as setas são do vídeo (avançar e voltar), e trocar de avaliação apagaria o vídeo */
        if (e.target.closest && e.target.closest('video, audio, iframe')) return;
        if (e.key === 'ArrowLeft' && !btPrev.disabled) { e.preventDefault(); andar(-1); }
        else if (e.key === 'ArrowRight' && !btNext.disabled) { e.preventDefault(); andar(1); }
      });

      q('[data-nt-leitor-fechar]').addEventListener('click', function () {
        voltarPara = null;
        folha.close();
      });
      /* clique fora da caixa fecha */
      folha.addEventListener('click', function (e) {
        if (e.target === folha) folha.close();
      });

      /* o foco volta para o cartão da avaliação que estava aberta. a largura pode ter mudado com o leitor
         aberto (o tablet girou), e a fileira repaginou pelo começo da página: ela volta para essa avaliação */
      folha.addEventListener('close', function () {
        quadro.querySelectorAll('video, iframe').forEach(function (m) { m.remove(); });
        if (voltarPara || !atual) return;
        sincronizarPagina(atual);
        if (atual.hidden) return;
        /* com a página remontada na nova largura, o cartão pode ter saído da tela na vertical */
        var naTela = atual.getBoundingClientRect();
        if (naTela.bottom <= 0 || naTela.top >= window.innerHeight) atual.scrollIntoView({ block: 'center', inline: 'nearest' });
        var botao = atual.querySelector('[data-nt-ler]');
        if (botao) botao.focus({ preventScroll: true });
      });
    }

    /* abas: escondem os cartões da outra origem e mandam a paginação recontar a partir da primeira página */
    function ligarAbas(raiz) {
      var barra = raiz.querySelector('[data-nt-aba]');
      if (!barra) return;
      var grade = raiz.querySelector('nt-reviews');
      raiz.querySelectorAll('[data-nt-aba]').forEach(function (aba) {
        aba.addEventListener('click', function () {
          var alvo = aba.dataset.ntAba;
          raiz.querySelectorAll('[data-nt-aba]').forEach(function (outra) {
            var on = outra === aba;
            outra.classList.toggle('is-active', on);
            outra.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          raiz.querySelectorAll('[data-nt-review]').forEach(function (card) {
            card.dataset.ntFora = card.dataset.ntOrigem === alvo ? '' : '1';
          });
          if (grade && grade.reset) grade.reset();
          /* no celular a fileira da outra aba começa do primeiro cartão */
          if (grade) grade.scrollLeft = 0;
        });
      });
      /* estado inicial: a aba de produto já nasce ativa no markup */
      raiz.querySelectorAll('[data-nt-review]').forEach(function (card) {
        card.dataset.ntFora = card.dataset.ntOrigem === 'produto' ? '' : '1';
      });
      if (grade && grade.reset) grade.reset();
    }

    /* a fileira de arrastar do celular e as páginas do desktop mostram a mesma avaliação quando a largura
       cruza o limite: a primeira à vista na fileira vira o começo da página, e o começo da página vai para o
       começo da fileira */
    function ligarFileira(raiz) {
      var grade = raiz.querySelector('nt-reviews');
      if (!grade || grade.dataset.ntFileira) return;
      grade.dataset.ntFileira = '1';
      var espera = 0;
      function rola() { return grade.scrollWidth > grade.clientWidth + 1; }
      function passo() {
        var c = grade.cards || [];
        if (c.length < 2) return 0;
        return c[1].getBoundingClientRect().left - c[0].getBoundingClientRect().left;
      }
      grade.addEventListener('scroll', function () {
        window.clearTimeout(espera);
        espera = window.setTimeout(function () {
          var p = passo();
          if (!rola() || p <= 0) return;
          grade.ancora = Math.min(grade.cards.length - 1, Math.round(grade.scrollLeft / p));
        }, 120);
      }, { passive: true });
      grade.addEventListener('nt-rev-render', function () {
        if (!rola()) return;
        var p = passo();
        var i = grade.ancora != null ? Math.min(grade.ancora, grade.cards.length - 1) : 0;
        if (p > 0) grade.scrollLeft = i * p;
      });
    }

    /* as fotos dos cartões chegam antes de aparecer. o lazy do navegador só pede a foto quando ela já está
       entrando na tela: na fileira de arrastar a seguinte fica fora da caixa que rola, e no desktop as páginas
       seguintes estão escondidas e nunca são pedidas antes do clique. aqui o loading do próprio cartão vira
       eager um pouco antes, e o navegador escolhe o arquivo pelo srcset e sizes do cartão, como faria */
    function ligarAquecimento(raiz) {
      var grade = raiz.querySelector('nt-reviews');
      if (!grade || grade.dataset.ntAquece) return;
      grade.dataset.ntAquece = '1';
      var perto = false;
      var quadro = 0;

      function rola() { return grade.scrollWidth > grade.clientWidth + 1; }
      function cartoes() { return grade.cards || []; }
      function fotoDe(card) { return card && card.querySelector('.nt-rev__foto img'); }
      function passo() {
        var c = cartoes();
        if (c.length < 2) return 0;
        return c[1].getBoundingClientRect().left - c[0].getBoundingClientRect().left;
      }
      function economia() { return !!(navigator.connection && navigator.connection.saveData); }
      /* conexão fraca ou economia de dados: só o que a pessoa já está para ver, nada em segundo plano */
      function fraca() {
        var c = navigator.connection;
        return !!c && (c.saveData || /2g|3g/.test(c.effectiveType || ''));
      }

      function pedir(card, devagar) {
        var img = fotoDe(card);
        if (!img || img.loading !== 'lazy') return img;
        if (devagar) img.fetchPriority = 'low';
        img.loading = 'eager';
        return img;
      }
      function pedirFaixa(de, ate) {
        var c = cartoes();
        for (var i = Math.max(0, de); i < Math.min(c.length, ate); i++) pedir(c[i]);
      }

      /* no celular, os três cartões à frente do que está na tela; no desktop, a página de antes e a de depois */
      function aquecerPerto() {
        quadro = 0;
        if (!perto || !cartoes().length) return;
        if (rola()) {
          var p = passo();
          var i = p > 0 ? Math.floor(grade.scrollLeft / p) : 0;
          var naTela = p > 0 ? Math.ceil(grade.clientWidth / p) : 1;
          pedirFaixa(i, i + naTela + 3);
        } else {
          var s = grade.size || 1;
          var pg = grade.page || 0;
          pedirFaixa((pg - 1) * s, (pg + 2) * s);
        }
      }
      function agendar() {
        if (!quadro) quadro = window.requestAnimationFrame(aquecerPerto);
      }
      grade.addEventListener('scroll', agendar, { passive: true });
      grade.addEventListener('nt-rev-render', agendar);

      if ('IntersectionObserver' in window) {
        /* a seção chegando perto da tela: os primeiros cartões (no desktop, a página 1 e a 2) */
        var chegada = new IntersectionObserver(function (entradas) {
          if (!entradas.some(function (e) { return e.isIntersecting; })) return;
          chegada.disconnect();
          perto = true;
          agendar();
        }, { rootMargin: '1250px 0px' });
        chegada.observe(raiz);

        /* no celular, o cartão parado inteiro na tela por um segundo é o que a pessoa está lendo: a foto do
           leitor dele vem antes do toque, que sozinho chega tarde demais para ela */
        var olhando = new Map();
        var olho = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            var card = e.target;
            if (e.intersectionRatio >= 0.9) {
              if (olhando.has(card)) return;
              olhando.set(card, window.setTimeout(function () {
                olhando.delete(card);
                if (rola() && !economia()) aquecerLeitor(card);
              }, 1000));
            } else if (olhando.has(card)) {
              window.clearTimeout(olhando.get(card));
              olhando.delete(card);
            }
          });
        }, { threshold: [0, 0.9] });
        grade.querySelectorAll('[data-nt-midia="1"]').forEach(function (card) { olho.observe(card); });
      } else {
        perto = true;
      }

      /* fila de fundo: com a página carregada e o navegador ocioso, as fotos dos cartões na ordem em que a pessoa
         vai vê-las (a da fileira, aba aberta), duas por vez e com prioridade baixa, até um teto: uns 10 cartões
         no celular, três páginas no desktop. as fotos grandes do leitor não entram */
      function fila() {
        if (fraca()) return;
        var celular = rola();
        var tetoFotos = celular ? 10 : (grade.size || 4) * 3;
        var tetoBytes = celular ? 1500000 : 3000000;
        var feitas = 0;
        var bytes = 0;
        var i = 0;
        var rodando = 0;
        function peso(img) {
          var lista = window.performance && performance.getEntriesByName ? performance.getEntriesByName(img.currentSrc || img.src) : [];
          var r = lista[lista.length - 1];
          /* foto de outro domínio sem o tamanho exposto conta como uma média */
          return r && r.encodedBodySize ? r.encodedBodySize : 80000;
        }
        function esperar(img) {
          var fim = false;
          function pronto() {
            if (fim) return;
            fim = true;
            rodando--;
            bytes += peso(img);
            proxima();
          }
          img.addEventListener('load', pronto, { once: true });
          img.addEventListener('error', pronto, { once: true });
          window.setTimeout(pronto, 15000);
        }
        function proxima() {
          var c = cartoes();
          while (rodando < 2 && i < c.length && feitas < tetoFotos && bytes < tetoBytes) {
            var card = c[i++];
            var img = fotoDe(card);
            if (!img) continue;
            feitas++;
            if (img.complete && img.naturalWidth) { bytes += peso(img); continue; }
            rodando++;
            esperar(pedir(card, true));
          }
        }
        proxima();
      }
      function ocioso() {
        if (window.requestIdleCallback) window.requestIdleCallback(fila, { timeout: 4000 });
        else window.setTimeout(fila, 300);
      }
      /* nada começa antes do load; o segundo de folga deixa passar o que os apps da loja carregam logo depois */
      function depoisDoLoad() { window.setTimeout(ocioso, 1000); }
      if (document.readyState === 'complete') depoisDoLoad();
      else window.addEventListener('load', depoisDoLoad, { once: true });
    }

    document.querySelectorAll('.nt-rev').forEach(function (raiz) {
      ligar(raiz);
      ligarAbas(raiz);
      ligarFileira(raiz);
      ligarAquecimento(raiz);
    });
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.nt-rev').forEach(function (raiz) {
        ligar(raiz);
        ligarAbas(raiz);
        ligarFileira(raiz);
        ligarAquecimento(raiz);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
